export interface TokenPayload {
  userId: string;
  // Presente só em sessões impersonadas ("acessar como" do painel admin) —
  // é o id do admin que entrou como o cliente.
  adminId?: string;
  exp: number;
}

export const decodeToken = (token: string): TokenPayload | null => {
  try {
    return JSON.parse(atob(token.split('.')[1])) as TokenPayload;
  } catch {
    return null;
  }
};

export const isTokenValid = (token: string): boolean => {
  const expiry = JSON.parse(atob(token.split('.')[1])).exp as number;

  return Math.floor(new Date().getTime() / 1000) < expiry;
};

/** true quando o token atual é de uma sessão impersonada (tem adminId). */
export const isImpersonationToken = (token: string): boolean =>
  !!decodeToken(token)?.adminId;
